export interface InfoFormValues {
  firstName: string
  lastName: string
  phoneNumber: string
  propertyId?: number
  street?: string
  postalCode?: string
  propertyType?:
    | 'detached_house'
    | 'semi_detached'
    | 'row_house'
    | 'apartment_building'
  notes?: string
}

export interface Property {
  id: number
  address?: {
    street: string
    city: string
    postalCode: string | null
  } | null
}

export const CITY_LABELS: Record<string, string> = {
  espoo: 'Espoo',
  helsinki: 'Helsinki',
  vantaa: 'Vantaa',
  kauniainen: 'Kauniainen',
  kirkkonummi: 'Kirkkonummi',
}
